import { Icon } from 'components/Icon/Icon';
import { ReactComponent as BackIcon } from 'assets/icons/main-24/back-o--24.svg';
import { Text, TextTypography } from 'components/Text/Text';
import { ProfileCard } from '../../UserMenu/ProfileCard';
import React, { useCallback } from 'react';
import i18n from '../../../../i18n';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { RoutePath } from 'RoutePath';

const useStyles = makeStyles(theme => ({
    profile: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        display: 'flex',
        padding: theme.spacing(2.5),
        borderBottom: `1px solid ${theme.palette.brandPrimary.accent}`,
    },
    title: {
        paddingRight: theme.spacing(3),
        width: '100%',
        textAlign: 'center',
    },
    contents: {
        flex: 1,
    },
    iconClickableContainer: {
        cursor: 'pointer',
    },
}));

export const VendorProfile = () => {
    const { t } = i18n.useTranslation();
    const history = useHistory();
    const classes = useStyles();
    const goToVendorDashboard = useCallback(() => history.push(RoutePath.VENDOR_DASHBOARD), [history]);
    return (
        <div className={classes.profile}>
            <div className={classes.header}>
                <div className={classes.iconClickableContainer} onClick={goToVendorDashboard}>
                    <Icon component={BackIcon} size={24} svgSize={24} />
                </div>
                <div className={classes.title}>
                    <Text typography={TextTypography.LEAD_ACCENT}>{t('common:userMenu.profile.title')}</Text>
                </div>
            </div>
            <div className={classes.contents}>
                <ProfileCard isVendorProfile={true} onClose={() => history.push(RoutePath.VENDOR_DASHBOARD)} />
            </div>
        </div>
    );
};
